// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"794d3b9e","977":"8deeee8b"}[chunkId] + ".chunk.js";
};